import { render } from "./image.vue?vue&type=template&id=6e6a4e4f&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"

import "./image.vue?vue&type=style&index=0&id=6e6a4e4f&lang=scss"
import "./image.vue?vue&type=style&index=1&id=6e6a4e4f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6a4e4f"]])

export default __exports__